module.exports = __webpack_public_path__ + "img/Business.db5bf117.svg";